import { useCallback, useMemo } from "react";

export default function useRewardsData({ rewards, activeRewardTab, sortOrder }) {
  const getSortedRewards = useCallback(
    (inputRewards = rewards) => {
      const filtered = inputRewards.filter(
        (reward) => reward.type === activeRewardTab
      );

      return filtered.sort((a, b) => {
        const dateA = new Date(a.createdAt);
        const dateB = new Date(b.createdAt);
        return sortOrder === "newest" ? dateB - dateA : dateA - dateB;
      });
    },
    [activeRewardTab, rewards, sortOrder]
  );

  const sortedRewards = useMemo(
    () => getSortedRewards(rewards),
    [getSortedRewards, rewards]
  );

  return {
    getSortedRewards,
    sortedRewards,
  };
}
